import UserFormErrorState from './UserFormErrorState';
import {Atom} from '@packages/systems/wfdl';

// eslint-disable-next-line unused-imports/no-unused-vars, unused-imports/no-unused-vars
const {style, ...userFormErrorStateConfig} =
  Atom.getConfigShape(UserFormErrorState);

// note: this atom is identical to UserFormErrorState and only exists because we are unable to set different styles for different instances of the same atom.
export default Atom.create(userFormErrorStateConfig);
